import { PageTitle } from '_metronic/layout/core'
import { WithChildren } from '_metronic/helpers'

import ViewDetailModal from 'Presentation/Views/SaleOrder/Detail/View'

import PageBreadCrumb from 'Presentation/Components/PageBreadCrumb'
import { ServerSideTable } from 'Presentation/Components/Table'
import { KTSVG } from '_metronic/helpers'

import Filter from './Components/Filter'

import useViewModel from './ViewModel'
import { isMobile } from 'react-device-detect'
import clsx from 'clsx'

const SaleOrderListView: React.FC = () => {
  const {
    isHideWritingAction,
    data,
    totalData,
    TABLE_CONFIGS,
    handleOpenFormModal,
    exportData,
    filter,
    onChangeFilter,
    nextPageDesktop,
    submitFilter,
    clearFilter,
  } = useViewModel()

  return (
    <>
      <ViewPageTitle>
        <Filter
          filter={filter}
          onChangeFilter={onChangeFilter}
          onSubmit={submitFilter}
          onClearFilter={clearFilter}
        />
        <ViewDetailModal />

        <div className='row gy-5 mb-5'>
          <div className='col-12'>
            <PageBreadCrumb />
          </div>

          {/* begin:: Table */}
          <div className='col-12'>
            <div className='card'>
              {/* begin:: Header */}
              <div className='card-header'>
                <div className='card-title'></div>
                {/* <div className='card-title w-75 me-0'>
                <div className='row align-items-center w-100'>
                  <div className='col-12 col-xl-4 mb-5 mb-xl-0'>
                    <div className='d-flex flex-row align-items-center'>
                      <label
                        className='d-none d-xl-block me-4 fs-7 fw-bold'
                        style={{ whiteSpace: 'nowrap' }}>
                        วันที่เริ่มต้น:{' '}
                      </label>
                      <Datetime
                        locale='en'
                        dateFormat='DD/MM/YYYY'
                        timeFormat={false}
                        inputProps={{
                          placeholder: '',
                        }}
                        renderInput={props => {
                          return <input {...props} autoComplete='off' />
                        }}
                        closeOnClickOutside
                        className='filter-date-input w-100'
                      />
                    </div>
                  </div>

                  <div className='col-12 col-xl-4 mb-5 mb-xl-0'>
                    <div className='d-flex flex-row align-items-center'>
                      <label
                        className=' d-none d-xl-block me-4 fs-7 fw-bold'
                        style={{ whiteSpace: 'nowrap' }}>
                        วันที่สิ้นสุด:{' '}
                      </label>
                      <Datetime
                        locale='en'
                        dateFormat='DD/MM/YYYY'
                        timeFormat={false}
                        inputProps={{
                          placeholder: '',
                        }}
                        renderInput={props => {
                          return <input {...props} autoComplete='off' />
                        }}
                        closeOnClickOutside
                        className='filter-date-input w-100'
                      />
                    </div>
                  </div>

                  <div className='col-12 col-xl-4 mb-5 mb-xl-0'>
                    <div className='d-flex flex-row align-items-center'>
                      <button className='btn btn-sm btn-primary fw-bold'>ค้นหา</button>
                    </div>
                  </div>
                </div>
              </div> */}
                {/* end:: Header */}

                <div
                  className='w-100 card-toolbar flex-column flex-xl-row align-items-start align-items-xl-end justify-content-end pb-5'
                  style={{ rowGap: '12px' }}>
                  {!isHideWritingAction && (
                    <button
                      onClick={handleOpenFormModal}
                      className={clsx('btn btn-sm btn-light-success me-4 fw-bold', {
                        'w-100': isMobile,
                      })}
                      style={{ whiteSpace: 'nowrap' }}>
                      <KTSVG
                        path='/media/icons/duotune/files/fil018.svg'
                        svgClassName='svg-icon-1'
                      />
                      เพิ่มรายการ
                    </button>
                  )}

                  <button
                    className={clsx('btn btn-sm btn-light-warning me-4 fw-bold', {
                      'w-100': isMobile,
                    })}
                    style={{ whiteSpace: 'nowrap' }}
                    onClick={exportData}>
                    <KTSVG path='/media/icons/duotune/files/fil017.svg' svgClassName='svg-icon-1' />
                    นำออกเอกสาร
                  </button>

                  <button
                    className={clsx('btn btn-sm btn-light-primary fw-bold', {
                      'w-100': isMobile,
                    })}
                    id='kt_sale_order_filter_toggle'
                    style={{ whiteSpace: 'nowrap' }}>
                    <KTSVG
                      path='/media/icons/duotune/general/gen004.svg'
                      svgClassName='svg-icon-1'
                    />
                    ค้นหา
                  </button>
                </div>
              </div>
              {/* end:: Header */}

              {/* begin:: Body */}
              <div className='card-body horizontal-paddingless'>
                <ServerSideTable
                  pagination
                  isGrey
                  page={filter.page}
                  data={data}
                  columns={TABLE_CONFIGS}
                  items_per_page={filter.pageSize}
                  totalData={totalData}
                  updatePage={page => {
                    if (page) {
                      nextPageDesktop(page)
                    }
                  }}
                />
              </div>
              {/* end:: Body */}
            </div>
          </div>
          {/* end:: Table */}
        </div>
      </ViewPageTitle>
    </>
  )
}

const ViewPageTitle: React.FC<WithChildren> = ({ children }) => {
  return (
    <>
      <PageTitle
        breadcrumbs={[
          {
            isActive: true,
            isSeparator: false,
            path: '#',
            title: 'รายการทั้งหมด',
            icon: '/media/icons/duotune/files/fil024.svg',
          },
        ]}>
        ใบสั่งขาย (SO)
      </PageTitle>

      {children}
    </>
  )
}

export default SaleOrderListView
